import httpCommon from "./http-common";
import { trackApiCall } from "../utils/debug-utils";

// Tax Types
const getAllTaxTypes = () => {
  trackApiCall("getAllTaxTypes");
  return httpCommon.get("/v1/get/taxTypes");
};

const getTaxType = (id: number) => {
  trackApiCall("getTaxType", { id });
  return httpCommon.get(`/v1/get/taxType/${id}`);
};

const createTaxType = (data: any) => {
  trackApiCall("createTaxType", { data });
  return httpCommon.post("/v1/add/taxType", data);
};

const updateTaxType = (id: number, data: any) => {
  trackApiCall("updateTaxType", { id, data });
  return httpCommon.put(`/v1/update/taxType/${id}`, data);
};

const deleteTaxType = (id: number) => {
  trackApiCall("deleteTaxType", { id });
  return httpCommon.delete(`/v1/delete/taxType/${id}`);
};

// Default Taxes
const getAllDefaultTaxes = () => {
  trackApiCall("getAllDefaultTaxes");
  return httpCommon.get("/v1/get/defaultTaxes");
};

const getDefaultTax = (id: number) => {
  trackApiCall("getDefaultTax", { id });
  return httpCommon.get(`/v1/get/defaultTax/${id}`);
};

const getDefaultTaxesByCountry = (country: string) => {
  trackApiCall("getDefaultTaxesByCountry", { country });
  return httpCommon.get(`/v1/get/defaultTaxesByCountry/${country}`);
};

const createDefaultTax = (data: any) => {
  trackApiCall("createDefaultTax", { data });
  return httpCommon.post("/v1/add/defaultTax", data);
};

const updateDefaultTax = (id: number, data: any) => {
  trackApiCall("updateDefaultTax", { id, data });
  return httpCommon.put(`/v1/update/defaultTax/${id}`, data);
};

const deleteDefaultTax = (id: number) => {
  trackApiCall("deleteDefaultTax", { id });
  return httpCommon.delete(`/v1/delete/defaultTax/${id}`);
};

// Business Tax Info
const getBusinessTaxInfos = (businessId: number) => {
  trackApiCall("getBusinessTaxInfos", { businessId });
  return httpCommon.get(`/v1/get/businessTaxInfos/${businessId}`);
};

const createBusinessTaxInfo = (businessId: number, data: any) => {
  trackApiCall("createBusinessTaxInfo", { data });
  return httpCommon.post(`/v1/add/businessTaxInfo/${businessId}`, data);
};

const updateBusinessTaxInfo = (id: number, data: any) => {
  trackApiCall("updateBusinessTaxInfo", { id, data });
  return httpCommon.put(`/v1/update/businessTaxInfo/${id}`, data);
};

const deleteBusinessTaxInfo = (id: number) => {
  trackApiCall("deleteBusinessTaxInfo", { id });
  return httpCommon.delete(`/v1/delete/businessTaxInfo/${id}`);
};

// Customer Tax Info
const getCustomerTaxInfos = (customerId: number) => {
  trackApiCall("getCustomerTaxInfos", { customerId });
  return httpCommon.get(`/v1/get/customerTaxInfos/${customerId}`);
};

const createCustomerTaxInfo = (data: any) => {
  trackApiCall("createCustomerTaxInfo", { data });
  return httpCommon.post("/v1/add/customerTaxInfo", data);
};

const updateCustomerTaxInfo = (publicId: string, data: any) => {
  trackApiCall("updateCustomerTaxInfo", { data });
  return httpCommon.put(`/v1/update/customerTaxInfo/${publicId}`, data);
};

const deleteCustomerTaxInfo = (id: number) => {
  trackApiCall("deleteCustomerTaxInfo", { id });
  return httpCommon.delete(`/v1/delete/customerTaxInfo/${id}`);
};

const TaxesService = {
  // Tax Types
  getAllTaxTypes,
  getTaxType,
  createTaxType,
  updateTaxType,
  deleteTaxType,

  // Default Taxes
  getAllDefaultTaxes,
  getDefaultTax,
  getDefaultTaxesByCountry,
  createDefaultTax,
  updateDefaultTax,
  deleteDefaultTax,

  // Business Tax Info
  getBusinessTaxInfos,
  createBusinessTaxInfo,
  updateBusinessTaxInfo,
  deleteBusinessTaxInfo,

  // Customer Tax Info
  getCustomerTaxInfos,
  createCustomerTaxInfo,
  updateCustomerTaxInfo,
  deleteCustomerTaxInfo
};

export default TaxesService; 